import BubbleTextBox from '../../../BubbleTextBox/BubbleTextBox';
import { StyledQuestionInteractionBubble } from './QuestionInteractionBubble.styled';

export default function QuestionInteractionBubble({ onClick, bubble }) {
  return (
    <StyledQuestionInteractionBubble
      className="bubble enabled"
      onClick={onClick}
    >
      <BubbleTextBox playing bubble={bubble} className="interaction-bubble" />
    </StyledQuestionInteractionBubble>
  );
}
